export default __webpack_public_path__ + "static/media/IMG_6760 - Copy.f7b96694.jpg";